enum GivingType {
    OneTimePayment = 1,
    RecurringPayment = 2,
}

export default GivingType;
